import { BaseService } from 'src/app/shared/services/base.service';
import * as i0 from "@angular/core";
import * as i1 from "./feathers.service";
export class MatchService extends BaseService {
    constructor(feathers) {
        super("match", feathers.app);
    }
}
MatchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MatchService_Factory() { return new MatchService(i0.ɵɵinject(i1.FeathersService)); }, token: MatchService, providedIn: "root" });
